export type DemoScenarioId = "ready" | "almost" | "needs";

export interface ScenarioConfig {
  id: DemoScenarioId;
  label: string;
  description: string;
  /** Target chapter completion ratio (0..1) */
  chapterCompletionRatio: number;
  /** Target per-chapter score range when attempted (0..100) */
  chapterScoreRange: [number, number];
  /** Target practice accuracy across attempted questions (0..1) */
  practiceAccuracy: number;
  /** Target ratio of cert questions covered by practice sessions (0..1) */
  practiceCoverageRatio: number;
  /** Number of official mock exam attempts to fabricate per official set */
  mockAttemptsPerSet: [number, number];
  /** Score range for fabricated mock attempts (0..100) */
  mockScoreRange: [number, number];
  /** Ratio of keywords practiced/mastered per chapter (0..1) */
  keywordCoverageRatio: number;
  /** Per-keyword mastery probability (0..1) given it was practiced */
  keywordMasteryProb: number;
  /** Spread of activity across the last N days */
  activityDays: number;
}

export const SCENARIOS: Record<DemoScenarioId, ScenarioConfig> = {
  ready: {
    id: "ready",
    label: "Ready for Exam",
    description: "Strong scores across the board (96–100% readiness).",
    chapterCompletionRatio: 1,
    chapterScoreRange: [88, 99],
    practiceAccuracy: 0.94,
    practiceCoverageRatio: 1,
    mockAttemptsPerSet: [1, 2],
    mockScoreRange: [90, 99],
    keywordCoverageRatio: 1,
    keywordMasteryProb: 0.95,
    activityDays: 45,
  },
  almost: {
    id: "almost",
    label: "Almost Ready",
    description: "Most material covered with a few weak areas (80–90%).",
    chapterCompletionRatio: 0.9,
    chapterScoreRange: [70, 92],
    practiceAccuracy: 0.82,
    practiceCoverageRatio: 0.88,
    mockAttemptsPerSet: [1, 1],
    mockScoreRange: [78, 87],
    keywordCoverageRatio: 0.85,
    keywordMasteryProb: 0.78,
    activityDays: 30,
  },
  needs: {
    id: "needs",
    label: "Needs Improvement",
    description: "Early progress with significant gaps (40–65%).",
    chapterCompletionRatio: 0.45,
    chapterScoreRange: [38, 65],
    practiceAccuracy: 0.55,
    practiceCoverageRatio: 0.4,
    mockAttemptsPerSet: [0, 1],
    mockScoreRange: [42, 60],
    keywordCoverageRatio: 0.35,
    keywordMasteryProb: 0.5,
    activityDays: 18,
  },
};

export const SCENARIO_ORDER: DemoScenarioId[] = ["ready", "almost", "needs"];